import Layout from "../components/Layout";
import { TradeBlotter } from "../components/_Transactions/TradeBlotter";

const TradeBlotterPage = (props: any) => {
    return (
        <Layout>
            <TradeBlotter/>
        </Layout>
    )
}

export default TradeBlotterPage